module.exports = __webpack_public_path__ + "static/media/bg_notice_popup_reward.b3fea272.webp";